import { render, staticRenderFns } from "./gSwiperBox.vue?vue&type=template&id=6f5477a1&scoped=true"
import script from "./gSwiperBox.vue?vue&type=script&lang=js"
export * from "./gSwiperBox.vue?vue&type=script&lang=js"
import style0 from "./gSwiperBox.vue?vue&type=style&index=0&id=6f5477a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5477a1",
  null
  
)

export default component.exports